import type { Driver } from 'driver.js';

let instance: Driver | null = null;

export const setDriverInstance = (d: Driver | null) => {
	instance = d;
};

export const getDriverInstance = (): Driver | null => instance;

export const clearDriverInstance = () => {
	instance = null;
};

export const simulateTyping = async (args: {
	text: string,
	delay?: number,
	input: HTMLInputElement,
}) => {
	const {
		input,
		text,
		delay = 100,
	} = args;

	input.value = '';
	for (let i = 0; i < text.length; i++) {
		input.value += text[i];
		await new Promise((res) => setTimeout(res, delay));
	}

	input.setAttribute('value', input.value);
};
